import { Outlet } from "react-router-dom";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

const MainLayout = () => {
  return (
    <SimpleBar style={{ maxHeight: "99vh" }}>
      <div className="px-2 md:px-4">
        <Outlet />
      </div>
    </SimpleBar>
  );
};

export default MainLayout;
